import PropTypes from 'prop-types'
import { useContext, useState } from 'react'
import { CarritoContext } from '../../context/carritoContext'
import Imagen from '../../imagen/Imagen'
import Precios from '../precios/Precios'
import { SumarProductos } from '../sumarProductos/SumarProductos'
import styles from './PublicacionSinDetalle.module.css'

export const PublicacionSinDetalle = ({ publicacion, adjunto, loadingImagenes }) => {
  const { idPublicacion, titulo, precio, monSimb, cantDisponible, alicuota, porcDcto } = publicacion
  const [cantidad, setCantidad] = useState(1)
  const { onAgregarCarrito, setVerCarrito, setCantidadCompra } = useContext(CarritoContext)

  const incrementar = (e) => {
    e.stopPropagation()
    setCantidad((prev) => (prev < cantDisponible ? prev + 1 : prev))
  }
  const decrementar = (e) => {
    e.stopPropagation()
    setCantidad((prev) => (prev > 1 ? prev - 1 : 1))
  }

  const agregarAlCarrito = (e) => {
    e.stopPropagation()
    setVerCarrito(true)
    onAgregarCarrito(idPublicacion, cantidad)
    setCantidadCompra(1)
    setCantidad(1)
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.containerImagen}>
          <Imagen
            idPublicacion={idPublicacion}
            width={70}
            adjunto={adjunto}
            loadingImagenes={loadingImagenes}
          />
        </div>
        <SumarProductos
          cantidad={cantidad}
          setCantidad={setCantidad}
          decrementar={decrementar}
          incrementar={incrementar}
          cantDisponible={cantDisponible}
          agregarAlCarrito={agregarAlCarrito}
          styles={styles}
        />
      </div>
      <div className={styles.detalleContainer}>
        <p className={styles.titulo}>{titulo}</p>
        <Precios
          precio={precio}
          monedaSimbolo={monSimb}
          alicuota={alicuota}
          mostrarDescuento={!!porcDcto && porcDcto > 0}
          porcDcto={porcDcto}
          showSinIVA={true}
        />
      </div>
    </>
  )
}

PublicacionSinDetalle.propTypes = {
  publicacion: PropTypes.shape({
    idPublicacion: PropTypes.number.isRequired,
    titulo: PropTypes.string.isRequired,
    precio: PropTypes.number.isRequired,
    monSimb: PropTypes.string.isRequired,
    cantDisponible: PropTypes.number.isRequired,
    alicuota: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    porcDcto: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }).isRequired,
  adjunto: PropTypes.object,
  loadingImagenes: PropTypes.bool.isRequired
}
